import React from 'react';
import withDrawingContainer, { withDrawingContainerProps } from './withDrawingContainer';
import { Line, Text, Rect } from 'react-konva';
import { DrawingType, PoiUpdateDetails, poiPointSize } from '../constants';
import { usePoiDrawingColor } from 'redux/hooks/well';
import { convertRGBToHex } from 'utils/Global';

interface Props extends withDrawingContainerProps {
  name: string;
  color?: string;
}
const points = [
  0 - poiPointSize,
  0,
  0 + poiPointSize,
  0,
  0,
  0,
  0,
  0 - poiPointSize,
  0,
  0 + poiPointSize,
];

const PoiDrawing = (props: Props) => {
  const { id, name, color, isSelected } = props;
  const poiDrawingColor = usePoiDrawingColor();
  const hexColour = color ? convertRGBToHex(color) : poiDrawingColor;

  return (
    <>
      <Rect
        id={`poidrawing-rect-${name}`}
        x={-poiPointSize}
        y={-poiPointSize}
        width={poiPointSize * 2}
        height={poiPointSize * 2}
      />
      <Line
        id={`poidrawing-line-${id}`}
        points={points}
        stroke={hexColour}
        strokeWidth={2}
        shadowBlur={isSelected ? 10 : 0}
        shadowColor={isSelected ? 'black' : ''}
        shadowOpacity={isSelected ? 5 : 0}
        shadowEnabled={isSelected ? true : false}
      />
      <Text
        id={`poidrawing-text-${id}`}
        x={-poiPointSize}
        y={-poiPointSize}
        fontSize={poiPointSize * 0.5}
        textAnchor="middle"
        text={name}
        fill={hexColour}
      ></Text>
    </>
  );
};

function moveActionPreProcessor(props: Props, x: number, y: number): PoiUpdateDetails {
  const [transformedX, transformedY] = props.tpObject.FromCanvasToDb(x, y);
  return { x, y, dbX: transformedX, dbY: transformedY };
}

export default withDrawingContainer(PoiDrawing, DrawingType.POI, moveActionPreProcessor);
